import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { asyncForEach } from 'src/app/helpers/asyncForEach';
import { to64decode } from 'src/app/helpers/base64';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { getLanguageCookie } from 'src/assets/language';

@Component({
  selector: 'app-access-user',
  templateUrl: './access-user.component.html',
  styleUrls: ['./access-user.component.scss']
})
export class AccessUserComponent {
  @Input() parameters: any
  @Output() toggleModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() setArrayAccessUsers: EventEmitter<any> = new EventEmitter<any>();
  @Input() isShowCascade: boolean = true;

  task: any = {
    color: 'seccondary',
  };

  searchText: string = ''
  indexTable: any = { startIndex: 0, endIndex: 0 }
  currentPage = 1;
  itemsPerPage = 5;
  totalPages = 1;
  displayedColumns: any = ['Access', 'User']
  dataSource: any;
  filteredDatasource: any = new MatTableDataSource<any>([])
  temp: any;
  isSearch: boolean = false

  isEdit: boolean = false;

  isCascade: boolean = false

  constructor(private profileService: ProfileService, private cdr: ChangeDetectorRef){
    this.dataSource = new MatTableDataSource<any>();
  }

  async ngOnInit(){
    this.dataSource.data = this.parameters.usersArray
    this.filteredDatasource.data = this.parameters.usersArray
    this.getTotalPages()

    this.parameters.node.access_users_array = this.parameters?.node?.access_users_array ?? []
    this.parameters.usersArray?.forEach((item: any) => {
      if(this.parameters.node.access_users_array.includes(this.isShowCascade ? item.uuid : item.email)){
        this.setAcess(item, true)
      }else{
        this.setAcess(item, false)
      }
    })

    this.temp = JSON.parse(JSON.stringify(this.parameters.node.access_users_array))
  }

  toggleCascade(){
    this.isCascade = !this.isCascade
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getNames(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  exitModal(hide: boolean = true): void {
    if (!hide) {
      return
    }

    this.toggleModal.emit();
  }

  async save() {
    this.setArrayAccessUsers.emit({isCascade: this.isCascade, node: this.parameters.node})
    this.exitModal()
  }

  async setAcess(element: any, status?: boolean) {  
    if (status !== undefined) {
      element.access = status;
    } else {
      element.access = !element.access;
    }
  
    const key = this.isShowCascade ? element.uuid : element.email;
  
    if (element.access) {
      if (!this.parameters.node.access_users_array.some((p: string) => p === key)) {
        this.parameters.node.access_users_array.push(key);
      }
    } else {
      this.parameters.node.access_users_array = this.parameters.node.access_users_array.filter(
        (p: string) => p !== key
      );
    }
  }
  

  isAllSelected(): boolean {
    let numSelected: number = 0;
    this.filteredDatasource.data.map((item: { access: any; }) => { numSelected = numSelected + (item.access ? 1 : 0) });
    const numRows = this.filteredDatasource.data.length;
    return numSelected === numRows;
  }

  async toggleAllRows() {
    let status: any = !this.isAllSelected()
    await asyncForEach(this.dataSource.data, async (item: any, index: number) => {
      await this.setAcess(item, status)
    });
  }

  cancel(){
    this.isEdit = false;
    this.parameters.node.access_users_array = JSON.parse(JSON.stringify(this.temp))
    this.ngOnInit()
  }

  async getDisplayedRows() {
    this.indexTable.startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.indexTable.endIndex = this.indexTable.startIndex + this.itemsPerPage;
  }

  async getTotalPages(isLastPage: boolean = false){
    this.totalPages = Math.ceil(this.filteredDatasource.data.length / this.itemsPerPage)
    if (this.totalPages == 0) this.totalPages = 1
    if ((this.currentPage >= this.totalPages && this.totalPages > 0) || isLastPage) {
      this.currentPage = this.totalPages;
    }
    await this.getDisplayedRows()
  }

  async choseItemsPage(number: number) {
    this.currentPage = 1;
    this.itemsPerPage = number;
    this.getTotalPages()
    this.cdr.detectChanges()
  }

  getRows(){
    return this.filteredDatasource.data.slice(this.indexTable.startIndex, this.indexTable.endIndex)
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  setCurrentPages(param: number){
    return this.currentPage = param
  }

  getItemsPerPage(): number{
    return this.itemsPerPage
  }

  getTotalNumberPages(){
    return this.totalPages
  }

  async search() {
    const searchText = this.searchText.toLowerCase()
    this.filteredDatasource.data = this.dataSource.data.filter( (item: { name: any;}) => item.name.toLowerCase().includes(searchText));
    this.getTotalPages()
    this.isSearch = true
  }

  clearFilter(){
    this.isSearch = false; 
    this.searchText = ''
    this.filteredDatasource.data = this.dataSource.data
    this.getTotalPages()
  }
}